import { API } from '../../shared/constants/constants';
import { cloudfrontRefreshTime } from '../../shared/constants/constants';

let cloudfrontRefreshTimeoutId = null;
let cloudfrontRefreshEnabled = false;

function scheduleNextRefresh() {
  if (typeof window === 'undefined' || !cloudfrontRefreshEnabled) {
    return;
  }

  if (cloudfrontRefreshTimeoutId !== null) {
    window.clearTimeout(cloudfrontRefreshTimeoutId);
  }

  cloudfrontRefreshTimeoutId = window.setTimeout(refreshCloudfrontCookies, cloudfrontRefreshTime);
}

export function stopCloudfrontRefreshTimer() {
  cloudfrontRefreshEnabled = false;

  if (typeof window !== 'undefined' && cloudfrontRefreshTimeoutId !== null) {
    window.clearTimeout(cloudfrontRefreshTimeoutId);
    cloudfrontRefreshTimeoutId = null;
  }
}

export function startCloudfrontRefreshTimer({ immediate = false } = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  stopCloudfrontRefreshTimer();
  cloudfrontRefreshEnabled = true;

  if (immediate) {
    refreshCloudfrontCookies();
  } else {
    scheduleNextRefresh();
  }
}

export default function refreshCloudfrontCookies() {
  if (!cloudfrontRefreshEnabled) {
    return;
  }

  API.put('/user/auth/files', {}, { withCredentials: true })
    .then((response) => {
      // call function every 45 minutes to get new signed cookies
      scheduleNextRefresh();
    })
    .catch((err) => {
      console.error('Authorization error. Please try again.');
      stopCloudfrontRefreshTimer();
      window.location.replace(process.env.REACT_APP_COGNITO_URL);
    });
}
